import { ref, onMounted, onBeforeUnmount } from "vue";

const hideOnScroll = ref(false);
const lastScroll = ref(0);
let scrollListenersCount = 0;
let scrollHandler = null;

export const useScrollHide = (threshold = 132) => {
  const handleScroll = () => {
    const currentScroll = window.scrollY;
    
    if (currentScroll > lastScroll.value && currentScroll > threshold) {
      hideOnScroll.value = true;
    } 
    else if (currentScroll < lastScroll.value || currentScroll < threshold) {
      hideOnScroll.value = false;
    }
    
    lastScroll.value = currentScroll;
  };

  onMounted(() => {
    scrollListenersCount++;
    if (!scrollHandler) {
      scrollHandler = handleScroll;
      window.addEventListener("scroll", scrollHandler, { passive: true });
      lastScroll.value = window.scrollY;
    }
  });

  onBeforeUnmount(() => {
    scrollListenersCount--;
    if (scrollListenersCount === 0 && scrollHandler) {
      window.removeEventListener("scroll", scrollHandler);
      scrollHandler = null;
    }
  });

  return {
    hideOnScroll,
    handleScroll
  };
};

